/**
 * The registry lives in @kit/shared so that packages @kit/events depends on
 * (@ballee/invoices, @ballee/legal-compliance) can read it without a cycle.
 * This module keeps the historical import path working.
 */
export {
  ASSIGNMENT_STATUSES,
  ASSIGNMENT_STATUS_GROUPS,
  CAST_STATUS_OR_FILTER,
  NOT_CAST_ASSIGNMENT_STATUSES,
  NOT_REMOVED_STATUS_OR_FILTER,
} from '@kit/shared/assignment-statuses';
export type {
  AssignmentStatus,
  AssignmentStatusGroup,
} from '@kit/shared/assignment-statuses';
